import React, { useEffect, useState, useLayoutEffect } from "react";
import * as API from "src/api/high_risk";
import * as REQ from "src/api/request";
import * as REFERENCE from "src/api/risk/reference";
import moment from "moment";
import { DatePicker, Input, Select, TreeSelect } from "antd";
import List from "src/pages/high_risk/register/list";
import Header from "src/pages/high_risk/register/header";
// ⚠ `DepartmentTreeCode` нь ГҮЙЦЭТГЭГЧИЙН нэгжид (доор) хэвээр
//   хэрэглэгдэнэ — тэр нь БН/хэсгийн бүтэцтэй ХАМААРАЛГҮЙ өөр талбар.
import DepartmentTreeCode from "src/components/departmentTreeCode";
import { UnitFilter } from "src/components/filters";
import { splitUnitCode } from "src/utils/unitCode";
import { useUserContext } from "src/contexts/userContext";
import { useHighRiskContext } from "src/contexts/high_risk/highriskContext";
import DeviceSection from "src/pages/high_risk/register/DeviceSection";
import { xabHrRefApi } from "src/api/xabApi";
import useAccessScope from "src/components/risk/useAccessScope";
import WorkerByTn from "src/pages/high_risk/register/WorkerByTn";
import JobAttach from "src/pages/high_risk/register/JobAttach";
import SignatureSection from "src/pages/high_risk/register/SignatureSection";
import ProvisionSection from "src/pages/high_risk/register/ProvisionSection";
import IsolationSection from "src/pages/high_risk/register/IsolationSection";
import BrigadeSection from "src/pages/high_risk/register/BrigadeSection";
import ShiftSection from "src/pages/high_risk/register/ShiftSection";
import MatrixCons from "src/components/Matrix_consequences";
import MatrixProb from "src/components/Matrix_probabilities";
import _ from "lodash";

import Swal from "sweetalert2";
import { linkHazardWork } from "src/api/hazard";

const { TextArea } = Input;
const { Option } = Select;
const { RangePicker } = DatePicker;

const Index = () => {
  const { user, message } = useUserContext();
  const { state, dispatch } = useHighRiskContext();
  // Бүтцийн нэгжийг ЭРХЭЭР хязгаарлана:
  //   factory (ХАБЭА хэлтэс / админ) → бүх нэгжээс сонгоно
  //   бусад                          → өөрийн нэгжээр ТҮГЖИГДЭНЭ
  // (getUserDepartment нь backend дээр аль хэдийн эрхээр шүүгддэг тул энэ нь
  //  давхар хамгаалалт бөгөөд UI дээр ойлгомжтой болгоно.)
  const scope = useAccessScope();
  const lockDept = scope.level !== "factory";
  const [list, setlist] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [open, setOpen] = useState(false);
  const [treelist, settreelist] = useState([]);
  // Өндөр эрсдэлтэй АЖЛЫН ТӨРЛИЙН лавлах (Inspection.ReferenceType →
  // "Өндөр эрсдэлтэй ажлын төрөл"). Migration-аар үүсгэгдэнэ; олдохгүй бол
  // сонгогч харагдахгүй, бүртгэл хуучин хэвээр ажиллана.
  const [jobTypes, setJobTypes] = useState([]);
  // Гэрээт гүйцэтгэгч байгууллагын лавлах (xab.hr_company, 194 мөр).
  // HRT-ээс шилжсэн — өмнө нь чөлөөт текстээр бичдэг байсан тул нэг
  // байгууллага олон янзаар бичигдэж, тайланд нэгтгэгддэггүй байв.
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    let alive = true;
    // ⚠ Лавлахын НЭГ эх сурвалж — `/xab/hr-job-types` (/highrisk/reference
    //   → «Ажлын төрөл» таб). Өмнө нь Inspection.Reference-ийг 2 дуудлагаар
    //   өөрөө уншдаг байсан тул лавлах засагдахад энд тусдаггүй байв.
    xabHrRefApi
      .jobTypes()
      .then((r) => {
        if (alive) setJobTypes(r?.items || []);
      })
      .catch(() => {
        if (alive) setJobTypes([]);
      });
    xabHrRefApi
      .companies({ limit: 500 })
      .then((r) => {
        if (alive) setCompanies(r?.items || []);
      })
      .catch(() => {
        if (alive) setCompanies([]);
      });
    return () => {
      alive = false;
    };
  }, []);

  useEffect(() => {
    if (
      state.register.selected_consequence !== null &&
      state.register.selected_consequence !== undefined &&
      state.register.selected_probability !== null &&
      state.register.selected_probability !== undefined
    ) {
      REFERENCE.getMatrixEqui(
        state.register.selected_consequence,
        state.register.selected_probability
      )
        .then((res) => {
          dispatch({
            type: "STATE",
            data: {
              register: {
                ...state.register,
                matrix_score: res.score,
                matrix_grade: res.grade,
                matrix_id: res.id,
              },
            },
          });
        })
        .catch((error) => {
          message({
            type: "error",
            error,
            title: "Эрсдлийн үнэлгээ татахад алдаа гарлаа",
          });
        });
    } else {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    state.register.selected_consequence,
    state.register.selected_probability,
  ]);

  // Засах modal нээгдэх үед matrix_id-аас үр дагавар/магадлалын ID-уудыг
  // сэргээж dropdown-уудад харагдуулна. (Зөвхөн "засах" үед — шинээр нэмэх
  // үед matrix_id нь 0/null, сонголтуудыг хэрэглэгч өөрөө хийнэ.)
  useEffect(() => {
    if (!state.register.modal) return;
    if (
      state.register.matrix_id &&
      state.register.selected_consequence == null &&
      state.register.selected_probability == null
    ) {
      REQ.getMatrix()
        .then((res) => {
          var m = _.find(res || [], { id: state.register.matrix_id });
          if (!m) return;
          dispatch({
            type: "STATE",
            data: {
              register: {
                ...state.register,
                selected_consequence: m.consequence_id,
                selected_probability: m.probability_id,
              },
            },
          });
        })
        .catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.register.modal, state.register.matrix_id]);

  // Цонх нээгдэхэд бүтцийн нэгж хоосон бол хэрэглэгчийн ӨӨРИЙН нэгжээр
  // дүүргэнэ. DepartmentTreeCode нь зөвхөн mount үед авто-сонгодог тул
  // цонхыг дахин нээхэд ажиллахгүй байсан.
  useEffect(() => {
    if (!state.register.modal) return;
    if (state.register.department_code) return;
    const own = user?.info?.tseh_code;
    if (!own) return;
    REQ.getUserDepartment()
      .then((res) => {
        const found = _.find(
          res || [],
          (a) => String(a.departmentcode) === String(own),
        );
        if (!found) return;
        dispatch({
          type: "STATE",
          data: {
            register: {
              ...state.register,
              department: found.departmentcode,
              department_code: found.departmentcode,
              department_name: found.departmentname,
            },
          },
        });
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.register.modal]);

  /* ── ХУУЧИН БҮРТГЭЛ ЗАСАХАД БН/ХЭСГИЙГ КОДООС НӨХНӨ ─────────────────
     Одоо сонгогч нь `tseh_code` / `negj_code`-оор ажилладаг. Гэвч 2026-09
     хүртэл ЗӨВХӨН `department_code` бичигдэж байсан тул хуучин мөр засахад
     хоёр сонгогч хоосон ирж, хэрэглэгч нэгжээ ДАХИН сонгох (эсвэл мартаж
     хадгалах) байдалд хүрнэ. Кодоос тайлж нөхнө — дүрэм нь backend-ийн
     `Utils/unit_split.bn_key`-тэй ИЖИЛ (src/utils/unitCode.js).

     ⚠ Нэрийг ЭНД зохиохгүй: backend жагсаалт дээр `tseh_name`/`negj_name`-ыг
       аль хэдийн нөхөж илгээдэг. Байхгүй бол сонгогч өөрөө лавлахаасаа
       нэрийг олно — кодыг л зөв өгөх нь хангалттай. */
  useEffect(() => {
    if (!state.register.modal) return;
    const dep = state.register.department_code;
    if (!dep || state.register.tseh_code) return;
    const parts = splitUnitCode(dep);
    if (!parts.tseh_code) return;
    dispatch({
      type: "STATE",
      data: {
        register: {
          ...state.register,
          tseh_code: parts.tseh_code,
          tseh_name: state.register.tseh_name || null,
          negj_code: parts.negj_code || null,
          negj_name: parts.negj_code ? state.register.negj_name || null : null,
        },
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.register.modal, state.register.department_code]);

  const valid = () => {
    let validation = "";

    // Ажлын хугацааны хязгаар — эхлэх/дуусах огноо заавал
    if (!state.register.start_date || !state.register.end_date) {
      validation += "Ажлын хугацаа (эхлэх — дуусах огноо) оруулна уу <br />";
    }
    // Ажлын төрөл — өмнө нь ҮРГЭЛЖ 0 илгээгддэг байсан тул нэг ч наряд
    // төрөлгүй бүртгэгдсэн. Одоо заавал сонгоно.
    if (!(state.register.type_ids || []).length && !state.register.type_id) {
      validation += "Ажлын төрлийг сонгоно уу <br />";
    }
    // Гүйцэтгэгч — дотоод нэгж эсвэл гэрээт байгууллага
    if (state.register.executor_type === "external" &&
        !state.register.executor_org_name) {
      validation += "Гэрээт гүйцэтгэгч байгууллагын нэрийг оруулна уу <br />";
    }

    if (validation !== "") {
      Swal.fire({
        icon: "warning",
        html: validation,
      });
    } else {
      // ⚠ ЗАСАХ ба ШИНЭ хоёрыг ЯЛГАНА. Өмнө нь хоёуланд нь `postRegister`
      //   дуудаж байсан тул наряд засах бүрд ШИНЭ мөр үүсч, нэг ажил
      //   хэд хэдэн удаа бүртгэгддэг байв.
      const editingId = state.register.id;
      const payload = {
        yearc: moment(state.register.yearc).format("YYYY"),
        // Олон төрөл — эхнийх нь үндсэн `type_id` (тайлан, join хэвээр).
        // Хуучин мөрийг засахад `type_ids` хоосон бол ганц `type_id`-г ашиглана.
        type_ids:
          (state.register.type_ids || []).length
            ? state.register.type_ids
            : state.register.type_id
            ? [state.register.type_id]
            : [],
        type_id:
          (state.register.type_ids || [])[0] || state.register.type_id || 0,
        department_code: state.register.department_code,
        department_name: state.register.department_name,
        // БН ба ХЭСЭГ — ТУСАД НЬ. Backend нь ирээгүй бол кодоос тайлдаг
        // (Utils/unit_split.py) ч маягтын утга нь үргэлж илүү зөв.
        tseh_code: state.register.tseh_code || null,
        tseh_name: state.register.tseh_name || null,
        negj_code: state.register.negj_code || null,
        negj_name: state.register.negj_name || null,
        jobdesc: state.register.jobdesc,
        comment: null, // state.register.comment,
        matrix_id: state.register.matrix_id,
        start_date: state.register.start_date || null,
        end_date: state.register.end_date || null,
        usertn: user.tn,
        // ── Наряд зөвшөөрөл ──
        // Захиалагч заагаагүй бол бүртгэсэн нэгжийг захиалагч гэж үзнэ
        customer_code:
          state.register.customer_code || state.register.department_code,
        customer_name:
          state.register.customer_name || state.register.department_name,
        customer_section_code: state.register.customer_section_code,
        customer_section_name: state.register.customer_section_name,
        executor_type: state.register.executor_type || "internal",
        executor_code: state.register.executor_code,
        executor_name: state.register.executor_name,
        executor_section_code: state.register.executor_section_code,
        executor_section_name: state.register.executor_section_name,
        executor_org_name: state.register.executor_org_name,
        shift_count: state.register.shift_count,
        worker_count: state.register.worker_count,
        permit_giver_tn: state.register.permit_giver_tn,
        permit_giver_name: state.register.permit_giver_name,
        permit_giver_position: state.register.permit_giver_position,
        foreman_tn: state.register.foreman_tn,
        foreman_name: state.register.foreman_name,
        foreman_position: state.register.foreman_position,
        // Хэвлэдэг маягтын текстэн хэсгүүд (§2 тусгай тэмдэглэл, §2.2
        // тусгаарлалт, §3.3 төсөл, §3.4 хэмжилт). Өмнө нь маягтад талбар
        // байгаагүй тул хэвлэсэн хуудсанд эдгээр хэсэг үргэлж хоосон гардаг байв.
        special_note: state.register.special_note,
        isolation_note: state.register.isolation_note,
        project_note: state.register.project_note,
        measure_note: state.register.measure_note,
        tech_card_no: state.register.tech_card_no,
        instruction_no: state.register.instruction_no,
        valid_from: state.register.valid_from,
        valid_to: state.register.valid_to,
        // ТТ + автоматаар санал болгосон карт/заавар (зөвшөөрлийн хуудасны
        // 2.2 / 3.1 / 3.2 хэсэг). Backend `save_job_links`-ээр хадгална.
        hr_devices: state.register.hr?.devices || [],
        hr_cards: state.register.hr?.cards || [],
        hr_safeties: state.register.hr?.safeties || [],
      };

      const request = editingId
        ? API.editRegister(editingId, payload)
        : API.postRegister(payload);

      request
        .then((res) => {
          // ⚠ ШИНЭ наряд — модалыг ХААХГҮЙ. §4-§7 (гарын үсэг, ээлж,
          //   бригад, арга хэмжээ) нь `id`-гаас хамаардаг тул модал
          //   хаагдвал хэрэглэгч жагсаалтаас дахин нээх шаардлагатай
          //   болж, урсгал тасардаг байв. Одоо id-г шууд тавьж
          //   үргэлжлүүлнэ.
          const newId = editingId || res?.id;

          // ⚠ АЮУЛААС ҮҮССЭН НАРЯД — холбоос бичнэ. Энэ дуудлагагүй бол
          //   мөр «ирсэн ажил» банерт үлдэж, хоёр дахь наряд үүсэх
          //   эрсдэлтэй. Холбоос амжилтгүй болсон ч НАРЯД ҮҮССЭН хэвээр
          //   тул алдааг зөвхөн анхааруулга болгоно.
          if (!editingId && newId && state.register.from_hazard_id) {
            // ⚠ `message` нь antd-ийнх БИШ — `useUserContext`-ээс ирэх
            //   ФУНКЦ ({type, title}). `message.warning(...)` гэвэл унана.
            linkHazardWork(state.register.from_hazard_id, newId).catch(() => {
              message({
                type: "warning",
                title:
                  "Наряд үүссэн боловч аюултай холбогдсонгүй — жагсаалтад үлдэж магадгүй.",
              });
            });
          }
          dispatch({
            type: "STATE",
            data: {
              refresh: state.refresh + 1,
              end_date: state.register.yearc,
              department: state.register.department_code,
              register: {
                ...state.register,
                id: newId,
                modal: !editingId && !!newId,
              },
            },
          });
          message({
            type: "success",
            title: editingId
              ? "Амжилттай хадгалагдлаа."
              : "Хадгаллаа — одоо хариуцлагатай ИТА, ээлж, бригад, арга хэмжээгээ бөглөнө үү.",
          });
        })
        .catch((error) =>
          message({
            type: "error",
            error,
            title: "Хадгалахад алдаа гарлаа, дахин оролдно уу",
          })
        )
        .finally(() => {});
    }
  };

  useLayoutEffect(() => {
    REQ.getUserDepartment().then((res) => {
      var result = [];

      _.map(_.orderBy(res, ["departmentlevelid", "departmentcode"]), (item) => {
        result.push({
          ...item,
          title: item.departmentcode + " | " + item.departmentname,
          key: item.departmentcode,
          value: item.departmentcode,
          id: item.id,
          pId: item.parentid,
          selectable: item.departmentlevelid !== -1,
        });
      });

      settreelist(result);

      // Modal анх нээгдэх үед (шинээр нэмэх) header-ийн department/yearc-ийг
      // modal руу автомат уламжилна, ингэснээр хэрэглэгч дахин сонгох
      // шаардлагагүй болж, хадгалсаны дараа header filter-тэй заавал таарна.
      if (
        state.register.modal &&
        !state.register.id &&
        !state.register.department_code &&
        state.department &&
        state.department !== 0 &&
        state.department !== "0"
      ) {
        var match = _.find(res, (a) => a.departmentcode === state.department);
        if (match) {
          dispatch({
            type: "STATE",
            data: {
              register: {
                ...state.register,
                yearc: state.register.yearc || state.end_date || moment(),
                department: match.departmentcode,
                department_code: match.departmentcode,
                department_name: match.departmentname,
              },
            },
          });
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.register.id, state.register.modal]);

  const handleSelect = (value, node) => {
    console.log("valuee", value);
    setSelectedValue(value);

    // Find the parent item based on the selected value
    const parentItem = findParent(treelist, value);
    console.log(parentItem);
    if (parentItem) {
      console.log("Parent Value:", parentItem.value);
    }
  };

  const findParent = (data, targetValue) => {
    for (const item of data) {
      if (item.children) {
        if (item.children.some((child) => child.value === targetValue)) {
          console.log("item", item);
          return item;
        }
        const foundInChild = findParent(item.children, targetValue);
        if (foundInChild) {
          return foundInChild;
        }
      }
    }
    return null;
  };

  const readonly = !!state.register.readonly;

  return (
    <div className="flex flex-col text-xs">
      <div className="flex items-center">
        <span className="w-1/4 font-semibold">
          Огноо:<b className="ml-1 text-red-500">*</b>
        </span>
        <DatePicker
          allowClear={false}
          disabled={readonly}
          className="w-full md:w-[150px] text-xs"
          picker="year"
          value={moment(state.register.yearc)}
          onChange={(date) => {
            dispatch({
              type: "STATE",
              data: { register: { ...state.register, yearc: date } },
            });
          }}
        />
      </div>
      <hr className="my-2" />
      <div className="flex items-center">
        <span className="w-1/3 font-semibold">
          Ажлын хугацаа:<b className="ml-1 text-red-500">*</b>
        </span>
        <RangePicker
          allowClear
          disabled={readonly}
          className="w-full text-xs"
          format="YYYY-MM-DD"
          placeholder={["Эхлэх огноо", "Дуусах огноо"]}
          value={[
            state.register.start_date
              ? moment(state.register.start_date)
              : null,
            state.register.end_date ? moment(state.register.end_date) : null,
          ]}
          onChange={(dates) => {
            dispatch({
              type: "STATE",
              data: {
                register: {
                  ...state.register,
                  start_date: dates?.[0]
                    ? dates[0].format("YYYY-MM-DD")
                    : null,
                  end_date: dates?.[1] ? dates[1].format("YYYY-MM-DD") : null,
                },
              },
            });
          }}
        />
      </div>
      <hr className="my-2" />
      {/* ── БН (ЦЕХ/ХЭЛТЭС) + ХЭСЭГ — ХОЁР ТУСДАА ТАЛБАР ──────────────
          ⚠ Өмнө нь ганц мод сонгогч (`DepartmentTreeCode`) байсан тул
            хэрэглэгч ямар ч ТҮВШНИЙГ сонгож, бүгд НЭГ баганад
            (`department_code`) сууж байв — цех «25», хэсэг «2531», бүр
            групп «250501». Улмаар жагсаалтыг «БН-ээр групплэхэд» нэг
            цехийн наряд хэд хэдэн бүлэгт тарж, ХЭСГИЙН нэр БН-ийн
            мөрөнд гарч ирдэг байсан (2026-09-26).
          ⚠ ХОЁУЛАНГ илгээнэ (`tseh_*` ба `negj_*`). `department_code` нь
            ХАМГИЙН ДООД сонголт хэвээр — хуучин тайлан, дэлгэрэнгүй,
            хэвлэлт бүгд түүнийг уншдаг тул зан төлөв нь хэвээр үлдэнэ. */}
      <div className="flex items-center">
        <span className="w-1/3 font-semibold">
          Бүтцийн нэгж:<b className="ml-1 text-red-500">*</b>
        </span>
        {/* <TreeSelect
          showSearch
          allowClear={true}
          placeholder="Сонгоно уу"
          treeDataSimpleMode={true}
          className="w-full"
          treeData={treelist}
          treeLine={(true, { showLeafIcon: false })}
          filterTreeNode={(search, item) =>
            item.title.toLowerCase().indexOf(search.toLowerCase()) >= 0
          }
          open={open}
          onDropdownVisibleChange={(open) => setOpen(open)}
          onSelect={handleSelect}
        /> */}
        <div className="w-full flex flex-wrap gap-2">
          <UnitFilter
            disabled={readonly || lockDept}
            deptCode={state.register.tseh_code || undefined}
            deptParentId={state.register.tseh_parent_id}
            sectionCode={state.register.negj_code || undefined}
            onDeptChange={(code, parentId, name) => {
              dispatch({
                type: "STATE",
                data: {
                  register: {
                    ...state.register,
                    tseh_code: code || null,
                    tseh_name: name || null,
                    tseh_parent_id: parentId || null,
                    // Цех солигдоход хэсэг бүрэн тэглэгдэнэ — өмнөх
                    // цехийн хэсэг үлдвэл кодын угтвар зөрнө.
                    negj_code: null,
                    negj_name: null,
                    // Хамгийн доод сонголт = цех (хэсэг хараахан алга)
                    department: code || null,
                    department_code: code || null,
                    department_name: name || null,
                  },
                },
              });
            }}
            onSectionChange={(code, name) => {
              dispatch({
                type: "STATE",
                data: {
                  register: {
                    ...state.register,
                    negj_code: code || null,
                    negj_name: name || null,
                    // Хэсэг сонгогдвол ТЭР нь хамгийн доод нэгж; цуцлавал
                    // цех рүү буцна.
                    department: code || state.register.tseh_code || null,
                    department_code: code || state.register.tseh_code || null,
                    department_name: name || state.register.tseh_name || null,
                  },
                },
              });
            }}
          />
        </div>
      </div>
      {lockDept && (
        <div className="text-[10px] text-gray-400 pl-[33%]">
          Таны эрхийн дагуу {scope.scopeName} — өөрчлөх боломжгүй
        </div>
      )}
      {/* ── АЖЛЫН ТӨРӨЛ ────────────────────────────────────────────────
          `type_id` багана нь эхнээсээ байсан, backend нь Reference-тэй join
          хийдэг АТЛАА маягт үргэлж 0 илгээдэг байсан тул нэг ч наряд
          төрөлгүй бүртгэгдэж ирсэн. Лавлах бэлэн болмогц сонгогдоно. */}
      {jobTypes.length > 0 && (
        <>
          <hr className="my-2" />
          <div className="flex items-center">
            <span className="w-1/3 font-semibold">
              Ажлын төрөл:<b className="ml-1 text-red-500">*</b>
            </span>
            {/* ⚠ ОЛОН СОНГОЛТ (дээд тал нь 3). Нэг наряд хэд хэдэн өндөр
                эрсдэлтэй төрөлд зэрэг хамаардаг («өндөрт» + «цахилгаан»).
                Эхний сонголт нь ҮНДСЭН төрөл (type_id) — тайлан, join
                хэвээр; бүгд нь type_ids-д. Хуучин ганц type_id-тэй мөрийг
                засахад тэр нь жагсаалтад автоматаар орно. */}
            <Select
              mode="multiple"
              showSearch
              allowClear
              optionFilterProp="children"
              className="w-full text-xs"
              placeholder="Ажлын төрөл сонгоно уу (дээд тал нь 3)"
              disabled={readonly}
              maxTagCount="responsive"
              value={
                (state.register.type_ids || []).length
                  ? state.register.type_ids
                  : state.register.type_id
                  ? [state.register.type_id]
                  : []
              }
              onChange={(values) => {
                // 3-аас илүү сонговол сүүлийнхийг хүлээж авахгүй
                const next = (values || []).slice(0, 3);
                if ((values || []).length > 3) {
                  Swal.fire({
                    icon: "info",
                    text: "Ажлын төрөл дээд тал нь 3 сонгоно.",
                    timer: 1500,
                    showConfirmButton: false,
                  });
                }
                dispatch({
                  type: "STATE",
                  data: {
                    register: {
                      ...state.register,
                      type_ids: next,
                      type_id: next[0] || 0,
                    },
                  },
                });
              }}
            >
              {jobTypes.map((t) => (
                <Option key={t.id} value={t.id}>
                  {t.reference_name}
                </Option>
              ))}
            </Select>
          </div>
        </>
      )}

      {/* ── ГҮЙЦЭТГЭГЧ ──────────────────────────────────────────────────
          ODOO дээр гүйцэтгэгч нь дотоод нэгж ЭСВЭЛ гэрээт байгууллага
          байдаг (жш ""Засагт алтай" ХХК"). Одоо хүртэл огт бүртгэгддэггүй
          байсан тул гадны хүмүүс ямар нарядаар ажилласан нь мэдэгддэггүй. */}
      <hr className="my-2" />
      <div className="flex items-center">
        <span className="w-1/3 font-semibold">Гүйцэтгэгч:</span>
        <div className="w-full flex gap-2">
          <Select
            className="w-1/3 text-xs"
            disabled={readonly}
            value={state.register.executor_type || "internal"}
            onChange={(value) =>
              dispatch({
                type: "STATE",
                data: {
                  register: {
                    ...state.register,
                    executor_type: value,
                    // Төрөл солигдоход өмнөх сонголт үлдэх ёсгүй — нэг нь
                    // БН-ийн код, нөгөө нь байгууллагын id учир холилдоно
                    executor_code: null,
                    executor_name: null,
                    executor_org_name: null,
                    executor_section_code: null,
                    executor_section_name: null,
                  },
                },
              })
            }
          >
            <Option value="internal">Дотоод нэгж</Option>
            <Option value="external">Гэрээт байгууллага</Option>
          </Select>
          {state.register.executor_type === "external" ? (
            /* Гэрээт байгууллага — ЛАВЛАХААС сонгоно (xab.hr_company).
               Чөлөөт текстээр бичвэл нэг байгууллага олон янзаар бичигдэж,
               тайланд нэгтгэгдэхгүй болно. */
            <Select
              showSearch
              allowClear
              className="w-2/3 text-xs"
              disabled={readonly}
              placeholder='Гэрээт байгууллагаа сонгоно уу (жш "Тех-Монтаж ХХК")'
              optionFilterProp="children"
              value={state.register.executor_code || undefined}
              onChange={(value) => {
                const c = _.find(companies, (x) => String(x.legacy_id) === String(value));
                dispatch({
                  type: "STATE",
                  data: {
                    register: {
                      ...state.register,
                      executor_code: value ? String(value) : null,
                      executor_org_name: c ? c.name : null,
                      executor_name: null,
                    },
                  },
                });
              }}
            >
              {companies.map((c) => (
                <Option key={c.legacy_id} value={String(c.legacy_id)}>
                  {c.name}
                </Option>
              ))}
            </Select>
          ) : (
            /* Дотоод гүйцэтгэгч — БҮТЦИЙН НЭГЖИЙН модноос сонгоно */
            <div className="w-2/3">
              <DepartmentTreeCode
                value={state.register.executor_code}
                disabled={readonly}
                onChange={(value) => {
                  REQ.getUserDepartment().then((res) => {
                    const found = _.find(
                      res,
                      (a) => a.departmentcode === value,
                    );
                    dispatch({
                      type: "STATE",
                      data: {
                        register: {
                          ...state.register,
                          executor_code: value,
                          executor_name: found ? found.departmentname : "",
                          executor_org_name: null,
                        },
                      },
                    });
                  });
                }}
              />
            </div>
          )}
        </div>
      </div>

      {/* ── ЭЭЛЖ / АЖИЛЧДЫН ТОО ────────────────────────────────────────
          ODOO-гийн «ЭЭЛЖИЙН ТОО» ба «АЖИЛЧДЫН ТОО». Ажилчдын тоо нь
          ТӨЛӨВЛӨСӨН — бодит нь /highrisk/registerTn дээр бүртгэгдсэнээр
          тоологдож, зөрүү нь наряд өгөгчид хяналт болно. */}
      <hr className="my-2" />
      <div className="flex items-center">
        <span className="w-1/3 font-semibold">Ээлж / ажилчид:</span>
        <div className="w-full flex gap-2">
          <Input
            type="number"
            min={0}
            className="w-1/2 text-xs"
            placeholder="Ээлжийн тоо"
            disabled={readonly}
            value={state.register.shift_count ?? ""}
            onChange={(e) =>
              dispatch({
                type: "STATE",
                data: {
                  register: { ...state.register, shift_count: e.target.value },
                },
              })
            }
          />
          <Input
            type="number"
            min={0}
            className="w-1/2 text-xs"
            placeholder="Ажилчдын тоо (төлөвлөсөн)"
            disabled={readonly}
            value={state.register.worker_count ?? ""}
            onChange={(e) =>
              dispatch({
                type: "STATE",
                data: {
                  register: { ...state.register, worker_count: e.target.value },
                },
              })
            }
          />
        </div>
      </div>

      {/* ── ТОНОГ ТӨХӨӨРӨМЖ + автомат карт/заавар ──────────────────────
          HRT-ийн гол шийдэл: ТТ сонгоход 4,762 холбоосоос харгалзах
          технологийн карт, ХАБЭА-н зааврыг систем өөрөө олж өгнө. */}
      <hr className="my-2" />
      <DeviceSection
        value={state.register.hr}
        readonly={readonly}
        unitCode={state.register.department_code}
        // Сонгосон ажлын төрлөөр баримтыг шүүнэ — нэг ТТ дээр цахилгаан,
        // механик, засвар гэх мэт өөр ажилд өөр заавар/карт мөрдөгдөнө
        jobTypeIds={
          (state.register.type_ids || []).length
            ? state.register.type_ids
            : state.register.type_id
              ? [state.register.type_id]
              : []
        }
        onChange={(hr) =>
          dispatch({
            type: "STATE",
            data: { register: { ...state.register, hr } },
          })
        }
      />

      <hr className="my-2" />
      <div className="flex items-center">
        <span className="w-1/3 font-semibold pr-3">
          Хийж гүйцэтгэх ажил:<b className="ml-1 text-red-500">*</b>
        </span>
        <TextArea
          rows={4}
          placeholder="Зөрчлийн талаар дэлгэрэнгүй"
          value={state.register.jobdesc}
          className="w-full"
          disabled={readonly}
          onChange={(e) =>
            dispatch({
              type: "STATE",
              data: {
                register: { ...state.register, jobdesc: e.target.value },
              },
            })
          }
        />
      </div>

      {/* ── ХЭВЛЭДЭГ МАЯГТЫН ТЕКСТЭН ХЭСГҮҮД ────────────────────────────
          Зөвшөөрлийн хуудсанд байдаг мөртлөө өмнө нь маягтад талбаргүй
          байсан тул хэвлэхэд ҮРГЭЛЖ ХООСОН гардаг байв. */}
      {/* ── §2.2 ТУСГААРЛАЛТ ХИЙХ ТТ ───────────────────────────────────
          ⚠ Урьд нь чөлөөт TextArea байсан. Хэвлэхэд текст хоосон бол
            АЖИЛ ХИЙГДЭХ бүх ТТ-г цувуулж тавьдаг байв — гэтэл
            тусгаарлалт хийх ТТ нь ӨӨР төхөөрөмж (тэжээлийн шүүгээ,
            таслуур). Ажилтан буруу төхөөрөмж дээр цоож зүүх эрсдэлтэй
            тул лавлахаас СОНГОДОГ болгов. Хуучин текст нь түүхэн
            баримт учир `legacyNote`-оор харагдсаар байна. */}
      <div className="flex items-start mt-2">
        <span className="w-1/3 font-semibold pr-3">
          Тусгаарлалт хийх ТТ:
          <div className="text-xs font-normal text-slate-500">
            §2.2 · цахилгаан схем задлах, пайз, цоож
          </div>
        </span>
        <div className="w-full">
          <IsolationSection
            jobId={state.register.id}
            unitCode={state.register.department_code}
            readonly={readonly}
            legacyNote={state.register.isolation_note}
          />
        </div>
      </div>

      <div className="flex items-start mt-2">
        <span className="w-1/3 font-semibold pr-3">
          Тусгай тэмдэглэл:
          <div className="text-xs font-normal text-slate-500">
            §2 · мөр бүрийг шинэ мөрөнд
          </div>
        </span>
        <TextArea
          rows={3}
          placeholder="- ӨТМ ашиглахдаа эрх бүхий ажилтан томилох&#10;- Өндөрт ажиллахдаа шалгагдсан хамгаалалтын бүс ашиглах"
          value={state.register.special_note}
          className="w-full"
          disabled={readonly}
          onChange={(e) =>
            dispatch({
              type: "STATE",
              data: {
                register: { ...state.register, special_note: e.target.value },
              },
            })
          }
        />
      </div>

      <div className="flex items-center mt-2">
        <span className="w-1/3 font-semibold pr-3">
          Аюулгүй ажиллагааны төсөл:
          <div className="text-xs font-normal text-slate-500">§3.3</div>
        </span>
        <Input
          placeholder="Төслийн дугаар, нэр"
          value={state.register.project_note}
          className="w-full"
          disabled={readonly}
          onChange={(e) =>
            dispatch({
              type: "STATE",
              data: {
                register: { ...state.register, project_note: e.target.value },
              },
            })
          }
        />
      </div>

      <div className="flex items-center mt-2">
        <span className="w-1/3 font-semibold pr-3">
          Хэмжилт, шинжилгээ:
          <div className="text-xs font-normal text-slate-500">§3.4</div>
        </span>
        <Input
          placeholder="Хийн шинжилгээ, тусгаарлалтын эсэргүүцэл гэх мэт"
          value={state.register.measure_note}
          className="w-full"
          disabled={readonly}
          onChange={(e) =>
            dispatch({
              type: "STATE",
              data: {
                register: { ...state.register, measure_note: e.target.value },
              },
            })
          }
        />
      </div>

      <hr className="my-2" />

      <div className="flex items-center">
        <span className="w-1/3 font-semibold">
          Үр дагавар:<b className="ml-1 text-red-500">*</b>
        </span>
        <MatrixCons
          value={state.register.selected_consequence}
          disabled={readonly}
          onChange={(value) => {
            dispatch({
              type: "STATE",
              data: {
                register: { ...state.register, selected_consequence: value },
              },
            });
          }}
        />
      </div>
      <hr className="my-2" />
      <div className="flex items-center">
        <span className="w-1/3 font-semibold">
          Магадлал:<b className="ml-1 text-red-500">*</b>
        </span>
        <MatrixProb
          value={state.register.selected_probability}
          disabled={readonly}
          onChange={(value) => {
            dispatch({
              type: "STATE",
              data: {
                register: { ...state.register, selected_probability: value },
              },
            });
          }}
        />
      </div>
      <hr className="my-2" />
      <span className="flex justify-center font-semibold">
        Эрсдлийн үнэлгээ
      </span>

      <div className=" ">
        <div className="flex justify-center bg-[#efac2b]  w-full rounded-md py-2  text-white my-2">
          {(state.register?.matrix_score || "") +
            "-" +
            (state.register?.matrix_grade || "")}
        </div>
      </div>

      {/* ── НАРЯД ЗӨВШӨӨРӨЛ ────────────────────────────────────────────
          Наряд нь бүртгэл биш ЗӨВШӨӨРӨЛ: хэн, ямар баримтын үндсэн дээр,
          хэдийг хүртэл олгосныг бичнэ (Чухал хяналтын процесс.vsdx). */}
      <hr className="my-2" />
      <div className="bg-slate-50 border border-slate-200 rounded-md p-2 mb-2">
        <div className="font-semibold text-slate-700 mb-2">
          <i className="fas fa-file-signature mr-1" />
          Наряд зөвшөөрөл
        </div>

        {/* БД оруулаад ажилтны лавлахаас татна — гараар бичвэл нэг хүн
            олон янзаар бичигдэж, тайланд нэгтгэгдэхгүй болно. */}
        <div className="flex items-center mb-2">
          <span className="w-1/3">Наряд өгөгч:</span>
          <WorkerByTn
            disabled={readonly}
            tn={state.register.permit_giver_tn}
            name={state.register.permit_giver_name}
            position={state.register.permit_giver_position}
            onChange={(w) =>
              dispatch({
                type: "STATE",
                data: {
                  register: {
                    ...state.register,
                    permit_giver_tn: w.tn,
                    permit_giver_name: w.name,
                    permit_giver_position: w.position,
                  },
                },
              })
            }
          />
        </div>

        <div className="flex items-center mb-2">
          <span className="w-1/3">Ажил гүйцэтгэгч ахлагч:</span>
          <WorkerByTn
            disabled={readonly}
            tn={state.register.foreman_tn}
            name={state.register.foreman_name}
            position={state.register.foreman_position}
            onChange={(w) =>
              dispatch({
                type: "STATE",
                data: {
                  register: {
                    ...state.register,
                    foreman_tn: w.tn,
                    foreman_name: w.name,
                    foreman_position: w.position,
                  },
                },
              })
            }
          />
        </div>

        {/* ── §4 ХАРИУЦЛАГАТАЙ ИТА ────────────────────────────────────
            Дээрх «Наряд өгөгч» ба «Ажил гүйцэтгэгч ахлагч» нь ХОЁР л дүр.
            Хэвлэдэг маягтын §4-т ТАВАН дүр, тус бүр 4 хүртэл хүн гарын үсэг
            зурдаг (HRT: AT_Step4 × 5). Дутуугаар хэвлэсэн хуудас хүчингүй
            тул бүрэн бүрэлдэхүүнийг энд бүртгэнэ.

            ⚠ Дээрх 2 талбарыг ХЭВЭЭР үлдээв: хуучин наряд тэдгээрээр
              бичигдсэн, миграц нь тэднийг hr_job_signature руу хуулдаг.
              Хоёуланг зэрэг ажиллуулж, шилжилт дуусмагц дээрхийг хасна. */}
        <SignatureSection jobId={state.register.id} readonly={readonly} />

        {/* ── §7 УРЬДЧИЛАН СЭРГИЙЛЭХ АРГА ХЭМЖЭЭ ──────────────────────
            Зөвшөөрлийн хуудаснаас ТУСДАА хэвлэгддэг хоёр дахь цаас
            (HRT: Provision.rdlc). Ээлж бүрд ажилд оруулагч ба ажил
            гүйцэтгэгч хоёулаа шалгаж баталгаажуулна. */}
        <ProvisionSection jobId={state.register.id} readonly={readonly} />

        {/* ── §6 БРИГАДЫН БҮРЭЛДЭХҮҮН, ЗААВАРЧИЛГАА ──────────────────
            Бүрэлдэхүүн нь ӨЭА-д гарах ажилтны бүртгэлээс ирнэ; энд
            гишүүн бүрд ХЭН зааварчилсныг тэмдэглэнэ (HRT AT_Step6). */}
        {/* ── §5 ӨДӨР ТУТМЫН ЭХЛЭЛ, ТӨГСГӨЛ ─────────────────────────
            Наряд ажил дуустал нэг удаа олгогддог ч ээлж бүрд дахин
            нээгдэж хаагддаг (HRT AT_Step5). */}
        <ShiftSection jobId={state.register.id} readonly={readonly} />

        <BrigadeSection jobId={state.register.id} readonly={readonly} />

        {/* ── ХАВСРАХ БАРИМТ ─────────────────────────────────────────
            3.1 заавар ба 3.2 технологийн карт нь ТОНОГ ТӨХӨӨРӨМЖӨӨС
            автоматаар бөглөгддөг (дээрх «Тоног төхөөрөмж» хэсэг). Энд
            зөвхөн 3.3 «төсөл» / 3.4 «хэмжилтийн үр дүн» зэрэг БОДИТ
            баримтыг НЭР өгч хавсаргана. */}
        <div className="mb-2">
          <div className="mb-1">
            <span className="font-semibold">Хавсрах баримт:</span>
            <span className="text-[10px] text-gray-400 ml-2">
              Заавар / технологийн карт нь тоног төхөөрөмжөөс автоматаар
              бөглөгдөнө
            </span>
          </div>
          <JobAttach jobId={state.register.id} readonly={readonly} />
        </div>

        <div className="flex items-center">
          <span className="w-1/3">Зөвшөөрөл хүчинтэй:</span>
          <RangePicker
            allowClear
            showTime={{ format: "HH:mm" }}
            disabled={readonly}
            className="w-full text-xs"
            format="YYYY-MM-DD HH:mm"
            placeholder={["Эхлэх", "Дуусах"]}
            value={[
              state.register.valid_from ? moment(state.register.valid_from) : null,
              state.register.valid_to ? moment(state.register.valid_to) : null,
            ]}
            onChange={(dates) =>
              dispatch({
                type: "STATE",
                data: {
                  register: {
                    ...state.register,
                    valid_from: dates?.[0]
                      ? dates[0].format("YYYY-MM-DD HH:mm:ss")
                      : null,
                    valid_to: dates?.[1]
                      ? dates[1].format("YYYY-MM-DD HH:mm:ss")
                      : null,
                  },
                },
              })
            }
          />
        </div>
        <div className="text-[10px] text-slate-500 mt-1">
          Ажлын хугацаанаас БОГИНО байж болно — олон ээлж үргэлжлэх ажилд
          зөвшөөрлийг ээлж тутам сунгана.
        </div>
      </div>
      {!readonly && (
        <button
          className="w-full py-2 flex items-center justify-center font-semibold text-violet-500 border-2 border-violet-500 rounded-md hover:bg-violet-500 hover:text-white focus:outline-none duration-300 "
          onClick={() => {
            valid();
          }}
        >
          <i className="fas fa-save" />
          <span className="ml-2">Хадгалах</span>
        </button>
      )}
    </div>
  );
};

export default React.memo(Index);
